<div class="container well">
    <div class="well-title">
        <div class="col-md-12">Create Zonal Template</div>
    </div>
    <div class="col-md-12">
        <a class="back-link" routerLink="/configure/zonaltemplate">Back to Zonal Templates</a>
    </div>
    <div class="col-md-12 well-content">
        @if (error) {
            <div class="alert alert-danger">{{ error }}</div>
        }

        <form class="form-horizontal" [formGroup]="form" (ngSubmit)="save()">
            <div class="form-group">
                <label class="control-label col-md-2">Template Name</label>
                <div class="col-md-4">
                    <input type="text" class="form-control" formControlName="zonalTemplateName" />
                    @if (form.get("zonalTemplateName")?.touched && form.get("zonalTemplateName")?.invalid) {
                        <span class="text-danger"> Enter a template name </span>
                    }
                </div>
            </div>
            <div class="form-group">
                <label class="control-label col-md-2">Document Type</label>
                <div class="col-md-4">
                    <nz-select
                        formControlName="documentTypeId"
                        nzShowSearch
                        nzPlaceHolder="Select a document type"
                        style="width: 100%">
                        @for (dt of documentTypes; track dt) {
                            <nz-option [nzValue]="dt.DocumentTypeID" [nzLabel]="dt.DocumentTypeName"></nz-option>
                        }
                    </nz-select>
                    @if (form.get("documentTypeId")?.touched && form.get("documentTypeId")?.invalid) {
                        <span class="text-danger"> Select a document type </span>
                    }
                </div>
            </div>
            <div class="form-group">
                <label class="control-label col-md-2">Image/PDF</label>
                <div class="col-md-4">
                    <input type="file" class="form-control" (change)="onFileChange($event)" />
                </div>
            </div>
            <div class="form-group">
                <div class="col-md-offset-2 col-md-4">
                    <button type="submit" class="btn btn-default" [disabled]="saving">
                        {{ saving ? "Creating..." : "Create" }}
                    </button>
                </div>
            </div>
        </form>
    </div>
</div>
